import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-black text-white text-xl" }, "Deixe um Feedback", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UseIcon = _resolveComponent("UseIcon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = () => _ctx.emit('open-box')),
    id: "widget-open-button",
    class: "fixed z-50 bottom-0 right-0 mb-5 mr-5 bg-brand-main rounded-full py-3 px-5 flex items-center shadow-xl cursor-pointer select-none animate__animated animate__fadeInUp animate__faster"
  }, [
    _createVNode(_component_UseIcon, {
      class: "mr-3",
      name: "IconChat",
      color: "white",
      size: "27"
    }),
    _hoisted_1
  ]))
}